
import React from 'react';

export const PrivacyPolicy: React.FC = () => (
  <div className="bg-gray-50 min-h-screen py-24">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 bg-white p-12 md:p-20 rounded-3xl shadow-sm border border-gray-100 prose prose-slate max-w-none">
      <h1 className="text-4xl font-extrabold text-slate-900 mb-10">Privacy Policy</h1>
      <p className="text-slate-600 text-lg mb-8">Last Updated: October 2023</p>
      
      <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-6">Introduction</h2>
      <p>Welcome to EduZone.pk. We value your privacy and are committed to protecting your personal data. This privacy policy informs you about how we handle your personal data when you visit our website.</p>

      <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-6">Information We Collect</h2>
      <p>When you visit EduZone.pk, we may collect minimal information such as your IP address, browser type, and the pages you visit for analytical purposes to improve our user experience. If you contact us via WhatsApp or Email, we store that information purely for support purposes.</p>

      <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-6">Use of Information</h2>
      <ul className="list-disc pl-6 space-y-4">
        <li>To provide and maintain our Service.</li>
        <li>To notify you about changes to our Service.</li>
        <li>To provide student support.</li>
        <li>To gather analysis or valuable information so that we can improve the Service.</li>
      </ul>

      <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-6">Advertising & Cookies</h2>
      <p>Currently, EduZone.pk does not host third-party advertisements. However, we may use essential cookies to ensure the website functions correctly on your device.</p>
    </div>
  </div>
);

export const Disclaimer: React.FC = () => (
  <div className="bg-gray-50 min-h-screen py-24">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 bg-white p-12 md:p-20 rounded-3xl shadow-sm border border-gray-100 prose prose-slate max-w-none">
      <h1 className="text-4xl font-extrabold text-slate-900 mb-10">Disclaimer</h1>
      
      <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-6">Accuracy of Information</h2>
      <p>All the information on this website - EduZone.pk - is published in good faith and for general information and educational purposes only. While we strive to provide the most accurate notes for the All Board, EduZone does not make any warranties about the completeness, reliability, and accuracy of this information.</p>

      <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-6">Educational Content</h2>
      <p>The notes provided are "Sample Notes" and are intended to assist students in their studies. They should not be used as the sole source of preparation for board exams. We strongly recommend students to consult their official All Board textbooks.</p>

      <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-6">Not an Official Board Site</h2>
      <p>EduZone.pk is an independent educational portal and is NOT affiliated, associated, authorized, endorsed by, or in any way officially connected with BISE Lahore, the All Board, or any government education department in Pakistan.</p>

      <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-6">Changes to Content</h2>
      <p>We reserve the right to modify, add, or remove any part of the website's content without prior notice. Our team works continuously to upgrade sample notes to full notes.</p>
    </div>
  </div>
);
